import React from 'react';
import { FiSearch } from 'react-icons/fi';

interface SearchToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

/**
 * Dev-only toggle switch for enabling/disabling search enrichment.
 * When OFF: Backend skips the search_enrichment_node after citation_node
 * When ON: Full search enrichment flow runs (current behavior)
 * 
 * Default: OFF (disabled)
 */
const SearchToggle: React.FC<SearchToggleProps> = ({ enabled, onToggle }) => {
  return (
    <button
      onClick={() => onToggle(!enabled)}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium
        transition-all duration-200 border shadow-sm
        ${enabled 
          ? 'bg-primary/10 dark:bg-primary/20 border-primary/40 text-primary hover:bg-primary/20 dark:hover:bg-primary/30' 
          : 'bg-neutral/50 dark:bg-dark-accent border-neutral-dark dark:border-dark-border text-text-tertiary dark:text-dark-textSecondary hover:bg-neutral dark:hover:bg-dark-secondary'
        }`}
      title={enabled ? 'Enabled' : 'Disabled'}
      aria-pressed={enabled}
    >
      {/* Icon */}
      <span className={`transition-colors ${enabled ? 'text-primary' : 'text-text-tertiary dark:text-dark-textSecondary'}`}>
        {enabled ? <FiSearch size={14} /> : <FiSearch size={14} />}
      </span>
      
      {/* Label */}
      <span className="hidden sm:inline">Web Search</span>
      
      {/* Toggle Switch */}
      <div className={`relative w-8 h-4 rounded-full transition-colors ${
        enabled 
          ? 'bg-primary' 
          : 'bg-neutral-dark dark:bg-dark-border'
      }`}>
        <div 
          className={`absolute top-0.5 w-3 h-3 rounded-full bg-white shadow-sm transition-transform duration-200 ${
            enabled ? 'translate-x-4' : 'translate-x-0.5'
          }`} 
        />
      </div>
    </button>
  );
};

export default SearchToggle;
